import get from 'lodash/get';
import { GET_EXISTING_COMPONENTS_FULLFILLED } from 'app/CanvasComponent/const';
import { GET_PAGE_SUCCESS } from 'app/Page/const';
import { SET_RENDERING_ENV } from './const';
import { getRenderingEnvironment } from './helper';

/**
 * a reducer for renderingEnv state
 *
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
export const renderingEnvReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case GET_EXISTING_COMPONENTS_FULLFILLED: {
      const { PageType, PageTemplateName } = action.component && action.component.RenderingEnv;

      return getRenderingEnvironment(PageType, PageTemplateName);
    }
    case GET_PAGE_SUCCESS: {
      const { PageType } = get(action, ['page', 'Payload', 'MetadataFields']);
      const { PageTemplateName } = get(action, ['page', 'Payload']);

      return getRenderingEnvironment(PageType, PageTemplateName);
    }
    case SET_RENDERING_ENV: {
      const { pageType, pageTemplateName } = action.payload;

      return getRenderingEnvironment(pageType, pageTemplateName);
    }
    default:
      return state;
  }
};
